export default "__VITE_ASSET__Cv15eA8g__"